var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"turnstile-widget",class:{ 'turnstile-widget--error': !!_vm.errorMessage }},[_c('div',{ref:"host"}),(_vm.errorMessage)?_c('p',{staticClass:"help is-danger"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }